import './FilterCloud.css';
import React from 'react';

function FilterCloud(props) {
  const filters = Array.isArray(props.filters) ? props.filters : [];

  function onClick(asyncUrl) {
    props.onPropChange(typeof asyncUrl === 'string' ? asyncUrl : '');
  }

  return (
      <div className="section-cloud-tags-wrapper">
        <ul className="section-cloud-tags">
          {
            filters.map((filter, index) => (
                <li key={`cloud-filter-${index}`}>
                  <a href={filter.link}
                     onClick={(e) => {
                       e.preventDefault();
                       onClick(filter.asyns_url);
                     }}>
                    <span>{filter.filter_title}</span>
                  </a>
                </li>
            ))
          }
        </ul>
      </div>
  );
}

export default FilterCloud;